import { render, staticRenderFns } from "./typeFilter.vue?vue&type=template&id=0812dba9&scoped=true&"
import script from "./typeFilter.vue?vue&type=script&lang=js&"
export * from "./typeFilter.vue?vue&type=script&lang=js&"
import style0 from "./typeFilter.vue?vue&type=style&index=0&id=0812dba9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812dba9",
  null
  
)

export default component.exports